import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { isSampleId, SAMPLE_THEMES } from "./themes";
import SamplePaper from "./SamplePaper";
import SampleSignal from "./SampleSignal";
import SampleCloud from "./SampleCloud";
import SampleTide from "./SampleTide";
import SampleStudio from "./SampleStudio";
export default function SampleLanding() {
    const { id } = useParams();
    useEffect(() => {
        if (!isSampleId(id))
            return;
        const theme = SAMPLE_THEMES[id];
        document.title = `Evyely sample ${theme.number} — ${theme.name}`;
    }, [id]);
    if (!isSampleId(id))
        return _jsx(Navigate, { to: "/samples", replace: true });
    if (id === "paper")
        return _jsx(SamplePaper, {});
    if (id === "signal")
        return _jsx(SampleSignal, {});
    if (id === "cloud")
        return _jsx(SampleCloud, {});
    if (id === "tide")
        return _jsx(SampleTide, {});
    return _jsx(SampleStudio, {});
}
